import type { FC } from "react";
import { cx } from "@stubhub/broadway-foundation/css";
import { Heading, Text } from "@stubhub/broadway-web";
import type { EventListGridItem } from "src/http/api-types";
import { brandText, dateContainer, subtleText } from "src/website-apps/shared/components/event-date-time/styles";
import { useStableNow } from "src/website-apps/shared/hooks/useStableNow";
import { cardBorderedExplore, dayOfWeekContainerRecipe, largerDayTextRecipe } from "./ExploreDateCard.styled";

interface ExploreDateCardProps {
  event: EventListGridItem;
  brandColors?: boolean;
  disabled?: boolean;
}

/**
 * Simplified date card for explore mode
 * No feature toggles, no countdown, just clean date display
 */
export const ExploreDateCard: FC<ExploreDateCardProps> = ({ event, brandColors = true, disabled = false }) => {
  const formattedDate = event.formattedDate ?? ""; // e.g., "Dec 19"
  const [month, day] = formattedDate.split(" ", 2);
  const dayOfWeek = event.dayOfWeek ?? "";

  // Determine if we should show year or day of week
  const eventStartDateTime = event.eventMetadata?.common?.eventStartDateTime;
  const currentYear = useStableNow().year();
  const eventYear = eventStartDateTime ? new Date(eventStartDateTime).getFullYear() : currentYear;
  const startsThisYear = eventYear === currentYear;

  const nonDisabledText = brandColors ? brandText : subtleText;

  return (
    <div className={cardBorderedExplore}>
      <div className={dateContainer}>
        <Heading
          variant="title"
          size="small"
          as="h4"
          truncate
          className={cx(disabled ? undefined : brandColors && brandText)}
        >
          {month}
        </Heading>
        <Heading
          variant="title"
          size="medium"
          as="h4"
          truncate
          className={largerDayTextRecipe({ textColor: disabled ? "default" : brandColors ? "brand" : "default" })}
        >
          {day}
        </Heading>
      </div>
      <div className={dayOfWeekContainerRecipe({ bgVariant: brandColors && !disabled ? "brand" : "noBrand" })}>
        <Text variant="label" size="extra-small" className={cx(disabled ? undefined : nonDisabledText)} truncate>
          {startsThisYear ? dayOfWeek.toUpperCase() : eventYear}
        </Text>
      </div>
    </div>
  );
};
